import type React from "react"
import { createContext, useContext, useMemo, useState } from "react"

interface UserPreferencesContextType {
  showNullData: boolean
  setShowNullData: React.Dispatch<React.SetStateAction<boolean>>
}

const UserPreferencesContext = createContext<
  UserPreferencesContextType | undefined
>(undefined)

export const UserPreferencesProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [showNullData, setShowNullData] = useState(false)

  const value = useMemo(
    () => ({
      showNullData,
      setShowNullData,
    }),
    [showNullData]
  )

  return (
    <UserPreferencesContext.Provider value={value}>
      {children}
    </UserPreferencesContext.Provider>
  )
}

export const useUserPreferences = () => {
  const context = useContext(UserPreferencesContext)
  if (context === undefined) {
    throw new Error(
      "useUserPreferences must be used within a UserPreferencesProvider"
    )
  }
  return context
}
